// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__kXlYa {
  margin-top: auto;
}
.Footer_inner__CVEiR {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px;
  margin-top: 32px;
}
.Footer_logo__\\+JiYo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.Footer_logo__\\+JiYo img {
}
.Footer_logo__\\+JiYo span {
  height: 24px;
  width: 1px;
  background: #fff;
  margin: 0 16px;
}
.Footer_info__9S\\+0v {
  color: #fff;
  text-align: center;
  font-family: poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  direction: ltr;
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;AACA;AACA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".footer {\n  margin-top: auto;\n}\n.inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  margin-top: 32px;\n}\n.logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.logo img {\n}\n.logo span {\n  height: 24px;\n  width: 1px;\n  background: #fff;\n  margin: 0 16px;\n}\n.info {\n  color: #fff;\n  text-align: center;\n  font-family: poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  direction: ltr;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__kXlYa`,
	"inner": `Footer_inner__CVEiR`,
	"logo": `Footer_logo__+JiYo`,
	"info": `Footer_info__9S+0v`
};
export default ___CSS_LOADER_EXPORT___;
